<template>
  <div class="row position-relative">
    <div class="col-lg-12 mb-2 mb-lg-0">
      <input
        id="order_coupon_code"
        v-model="enteredValue"
        :placeholder="placeholder"
        type="text"
        name="order[coupon_code]"
        class="form-control ch-Confirm_CouponInput"
        autocomplete="off"
        @focus="toggleSuggestionsVisibility(true)"
        @blur="toggleSuggestionsVisibility(false)"
      />
    </div>
    <div class="col-lg-12 mb-0">
      <slot></slot>
    </div>
    <div
      v-if="vouchers.length"
      v-show="suggestionsVisible"
      class="col-lg-24 position-absolute itemSuggestions"
    >
      <div class="bg-white border rounded">
        <p class="h6 text-uppercase text-muted mb-1 p-2">{{ available_vouchers_heading }}</p>
        <div
          v-for="voucher in vouchers"
          :key="voucher.code"
          class="border-bottom d-flex justify-content-between p-2 text-small itemDivider"
          @mousedown="selectCouponCode(voucher.code)"
        >
          {{ voucher.code | voucherFilter }}
          <span class="text-primary icon icon-caret-right"></span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  filters: {
    voucherFilter(voucher) {
      let code = voucher.match(/.{1,3}/g);
      return [
        code
          .slice(0, -2)
          .map(code_part => "*".repeat(code_part.length))
          .join(" "),
        code.slice(-2).join(" "),
      ].join(" ");
    },
  },
  props: {
    available_vouchers_heading: {
      required: true,
      type: String,
    },
    placeholder: {
      required: true,
      type: String,
    },
  },
  data() {
    return {
      enteredValue: "",
      suggestionsVisible: false,
      vouchers: JSON.parse(window.localStorage.getItem("vouchers") || "[]"),
    };
  },
  methods: {
    toggleSuggestionsVisibility(visibility) {
      this.suggestionsVisible = visibility;
    },
    selectCouponCode(code) {
      this.enteredValue = code;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~styles/global";

.itemDivider:last-of-type {
  border: none;
}
.itemDivider:hover {
  cursor: pointer;
  background: $gray-100;
}

.itemSuggestions {
  top: 100%;
  z-index: $zi-higher;
}
</style>
